import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import AppLogList from './list/AppLogList';
import AppLogSearch from './list/components/AppLogSearch';

const AppLogs = (props) => {

  useEffect(() => {
    window.setAppTitle('App Logs');
  }, [])

  const handleOnRowClick = (data) => {
    props.history.replace({
      pathname: `/developers/audits/app-logs/${data.id}`,
      state: {
        data: {...data}
      }
    });
  }

  return (
    <div>
      { Guardian.allows('developer.logs.app') && (
        <>
        <Row>

          <Col sm="auto" md="9" className="mb-2">
            <AppLogSearch />
          </Col>

        </Row>

        <AppLogList onRowClick={ handleOnRowClick }/>
        </>
      )}
    </div>
  )
}

export default AppLogs;